/**
 * Job Family name-length rules (ER-11876).
 *
 * Job Family is an Org Object Code participant (Position / Role / Responsibility /
 * Department — Job Family concept page §9), so it shares the platform's existing
 * name-length ceiling. Both the picker's typed-query gating (which decides whether the
 * "+ Add Job Family" create row appears) and AddJobFamilyDialog's Name field read these
 * constants so the two cannot drift apart.
 */

/** Minimum typed length before a create affordance is offered. */
export const JOB_FAMILY_NAME_MIN_CHARACTERS = 3;

/** Maximum name length, matching TextInputWithLimit / AttachRolesResponsibilitiesPicker. */
export const JOB_FAMILY_NAME_MAX_CHARACTERS = 120;
